import __request__ from "routing/request";
export function system(requestOptions) {
  return __request__("GET", "/system", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function jvm(requestOptions) {
  return __request__("GET", "/system/jvm", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function locales(requestOptions) {
  return __request__("GET", "/system/locales", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function processBufferDump(requestOptions) {
  return __request__("GET", "/system/processbufferdump", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function threaddump(requestOptions) {
  return __request__("GET", "/system/threaddump", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function threadDumpAsText(requestOptions) {
  return __request__("GET", "/system/threaddump", null, {}, {
    "Accept": ["text/plain"]
  }, requestOptions);
}
